/**
 * Shared dummy data for teacher portal UI.
 * Flip USE_DUMMY_DATA to false when wiring live APIs.
 */
export const USE_DUMMY_DATA = false;

export const DUMMY_TEACHER = {
  id: 1,
  teacher_id: "ALS-BA-T-1",
  name: "Faiza Ahmed",
  email: "faiza@gmail.com",
  phone: "0300-1234567",
  subject: "Mathematics",
  subject_specialization: "Mathematics",
  employee_id: "EMP-1042",
  campus_id: 1,
  address: "Bahria Town, Phase 4",
  qualification: "M.Sc Mathematics",
  status: "Active",
};

export const DUMMY_CAMPUS = {
  id: 1,
  name: "ALS Bahria Campus",
  location: "Bahria Town, Islamabad",
  address: "Sector E, Bahria Town Phase 4",
  city: "Islamabad",
  principal: "Mr. Imran Khan",
  contact: "051-1234567",
  email: "bahria@alsdnk.com",
  total_students: 420,
  total_teachers: 28,
};

export const DUMMY_COURSES = [
  {
    id: 1,
    course_id: 1,
    course_name: "Mathematics",
    name: "Mathematics",
    class_name: "Class 10",
    section: "A",
    campus_id: 1,
  },
  {
    id: 2,
    course_id: 2,
    course_name: "Physics",
    name: "Physics",
    class_name: "Class 10",
    section: "A",
    campus_id: 1,
  },
  {
    id: 3,
    course_id: 3,
    course_name: "Chemistry",
    name: "Chemistry",
    class_name: "Class 9",
    section: "B",
    campus_id: 1,
  },
  {
    id: 4,
    course_id: 4,
    course_name: "Biology",
    name: "Biology",
    class_name: "Class 9",
    section: "B",
    campus_id: 1,
  },
];

export const DUMMY_TIMETABLE = [
  {
    id: 1,
    day_of_week: "Monday",
    period_number: 1,
    course_id: 1,
    course_name: "Mathematics",
    class_name: "Class 10",
    section: "A",
    room: "101",
    start_time: "08:00",
    end_time: "08:45",
  },
  {
    id: 2,
    day_of_week: "Monday",
    period_number: 2,
    course_id: 2,
    course_name: "Physics",
    class_name: "Class 10",
    section: "A",
    room: "102",
    start_time: "08:50",
    end_time: "09:35",
  },
  {
    id: 3,
    day_of_week: "Monday",
    period_number: 3,
    course_id: 3,
    course_name: "Chemistry",
    class_name: "Class 9",
    section: "B",
    room: "103",
    start_time: "09:40",
    end_time: "10:25",
  },
  {
    id: 4,
    day_of_week: "Tuesday",
    period_number: 1,
    course_id: 1,
    course_name: "Mathematics",
    class_name: "Class 9",
    section: "B",
    room: "101",
    start_time: "08:00",
    end_time: "08:45",
  },
  {
    id: 5,
    day_of_week: "Tuesday",
    period_number: 2,
    course_id: 4,
    course_name: "Biology",
    class_name: "Class 10",
    section: "A",
    room: "104",
    start_time: "08:50",
    end_time: "09:35",
  },
  {
    id: 6,
    day_of_week: "Wednesday",
    period_number: 1,
    course_id: 2,
    course_name: "Physics",
    class_name: "Class 9",
    section: "B",
    room: "102",
    start_time: "08:00",
    end_time: "08:45",
  },
  {
    id: 7,
    day_of_week: "Wednesday",
    period_number: 2,
    course_id: 1,
    course_name: "Mathematics",
    class_name: "Class 10",
    section: "A",
    room: "101",
    start_time: "08:50",
    end_time: "09:35",
  },
  {
    id: 8,
    day_of_week: "Thursday",
    period_number: 1,
    course_id: 3,
    course_name: "Chemistry",
    class_name: "Class 10",
    section: "A",
    room: "103",
    start_time: "08:00",
    end_time: "08:45",
  },
  {
    id: 9,
    day_of_week: "Thursday",
    period_number: 2,
    course_id: 4,
    course_name: "Biology",
    class_name: "Class 9",
    section: "B",
    room: "104",
    start_time: "08:50",
    end_time: "09:35",
  },
  {
    id: 10,
    day_of_week: "Friday",
    period_number: 1,
    course_id: 1,
    course_name: "Mathematics",
    class_name: "Class 10",
    section: "A",
    room: "101",
    start_time: "08:00",
    end_time: "08:45",
  },
  {
    id: 11,
    day_of_week: "Friday",
    period_number: 2,
    course_id: 2,
    course_name: "Physics",
    class_name: "Class 9",
    section: "B",
    room: "102",
    start_time: "08:50",
    end_time: "09:35",
  },
];

export const DUMMY_STUDENTS = [
  {
    id: 101,
    student_id: "ALS-BA-001",
    name: "Ahmed Khan",
    father_name: "Muhammad Khan",
    class_name: "Class 10",
    class_section: "A",
    course_id: 1,
    student_status: "Active",
    grade: "A",
  },
  {
    id: 102,
    student_id: "ALS-BA-002",
    name: "Fatima Ali",
    father_name: "Ali Ahmed",
    class_name: "Class 10",
    class_section: "A",
    course_id: 1,
    student_status: "Active",
    grade: "B+",
  },
  {
    id: 103,
    student_id: "ALS-BA-003",
    name: "Muhammad Usman",
    father_name: "Usman Ali",
    class_name: "Class 10",
    class_section: "A",
    course_id: 2,
    student_status: "Active",
    grade: "",
  },
  {
    id: 104,
    student_id: "ALS-BA-004",
    name: "Ayesha Bibi",
    father_name: "Muhammad Aslam",
    class_name: "Class 10",
    class_section: "A",
    course_id: 2,
    student_status: "Active",
    grade: "A-",
  },
  {
    id: 105,
    student_id: "ALS-BA-005",
    name: "Hassan Ali",
    father_name: "Ali Muhammad",
    class_name: "Class 9",
    class_section: "B",
    course_id: 3,
    student_status: "Active",
    grade: "B",
  },
  {
    id: 106,
    student_id: "ALS-BA-006",
    name: "Zainab Fatima",
    father_name: "Muhammad Akram",
    class_name: "Class 9",
    class_section: "B",
    course_id: 3,
    student_status: "Withdrawn",
    grade: "",
  },
  {
    id: 107,
    student_id: "ALS-BA-007",
    name: "Omar Farooq",
    father_name: "Farooq Ahmed",
    class_name: "Class 9",
    class_section: "B",
    course_id: 4,
    student_status: "Active",
    grade: "A",
  },
  {
    id: 108,
    student_id: "ALS-BA-008",
    name: "Mahnoor Ali",
    father_name: "Ali Hassan",
    class_name: "Class 9",
    class_section: "B",
    course_id: 4,
    student_status: "Active",
    grade: "",
  },
];

export const DUMMY_STATS = {
  total_students: 8,
  total_courses: 4,
  new_students: 2,
  withdrawn_students: 1,
  pending_grades: 3,
};

export const DUMMY_ACTIVITIES = [
  {
    type: "grade",
    description: "Updated grades for Class 10A Mathematics",
    time: "2 hours ago",
  },
  {
    type: "student",
    description: "New student Omar Farooq assigned to Biology",
    time: "Yesterday",
  },
  {
    type: "class",
    description: "Timetable updated for Friday periods",
    time: "2 days ago",
  },
];

export const DUMMY_REPORTS = [
  {
    id: 1,
    title: "Class 10A Midterm Summary",
    date: "Jul 18, 2026",
    type: "performance",
  },
  {
    id: 2,
    title: "Weekly Attendance — Week 28",
    date: "Jul 20, 2026",
    type: "attendance",
  },
  {
    id: 3,
    title: "Grade Distribution — June",
    date: "Jul 05, 2026",
    type: "grades",
  },
];

/** Students grouped by course id for attendance / grades screens */
export function studentsByCourseId(courseId) {
  const id = Number(courseId);
  return DUMMY_STUDENTS.filter((s) => s.course_id === id);
}
